import React from "react"
import _ from "lodash"

import coverImgSrc from "./exampleCover.jpg"
import questionLandscapeSrc from "./questionLandscape.jpg"
import questionPortraitSrc from "./questionPortrait.jpg"

const meta = (numResults: number, numTotalQuestions: number): Quiz.Api.Meta => {
  return {
    num_questions: numTotalQuestions,
    question_results: _.times(numResults, () => Math.random() > .5),
    title: "Do you know all your saturday morning cartoons?",
    points: 2,
    possible_points: 1009,
    type: "Quiz",
    released_at: "1.5.1983",
    ranking_url: "#VIEW_RANKINGS"
  }
}

const coverImage: Base.Api.ImageUrls = {"1x": coverImgSrc}
const video: Base.Api.Video = { media_url: "https://pix.sueddeutsche.de/2024/11/15/c1f34bb3-ebc0-4e86-8af6-299e8db39a0b.mp4" }
const questionImageWide: Base.Api.ImageUrls = {"1x": questionLandscapeSrc}
const questionImageTall: Base.Api.ImageUrls = {"1x": questionPortraitSrc}

const exampleOptin = "Ja, ich möchte am Gewinnspiel teilnehmen und erkläre mich mit den <a href='#TERMS'>Teilnahmebedingungen und Datenschutzbestimmungen</a> einverstanden. Teilnahmeschluss für diese Tagespreis-Verlosung ist am 24.12.2019, 10 Uhr. Teilnahmeschluss für die Hauptpreis-Verlosung ist am 27.12.2019, 10 Uhr. Die Teilnahme am Gewinnspiel ist kostenlos."
const longIntroText = `
<p>Menschen wollen unterwegs sein, jeder muss irgendwie von A nach B kommen. Wie könnte sich unsere Mobilität ändern? Und welche Weichen wurden dafür in diesem Jahr gestellt?</p>
<p>Testen Sie Ihr Wissen in unserem Sechs-Fragen-Quiz und sichern Sie sich Ihre Chance auf den aktuellen Tagespreis. Bei schwierigen Fragen können Sie einen der drei Joker unterhalb der Antwortmöglichkeiten einlösen. Wenn Sie alle Tages-Quizze erfolgreich lösen, nehmen Sie an unserer großen Hauptpreis-Verlosung teil."</p>
`
const share: Quiz.Api.ShareLinks = {
  facebook: "#facebook",
  twitter: "#twitter",
  mail: "#mail",
  whatsapp: "#whatsapp"
}

const defaultQuestion: Quiz.Api.Question = {
  text: "What is the answer?",
  config: { type: "multiple_choice", options: [{text: "Answer 1 has <i>HTML</i>", val: 1}, {text: "Answer 2", val: 2}, {text: "Answer 3", val: 3}] }
}

export interface IMockState {
  quiz?: Quiz.Api.Quiz
  busy?: boolean
}

type IMock = [string, () => IMockState, string?]
const getMocks = (): {section: string, mocks: IMock[]}[] => {
  const quiz = (q: Quiz.Api.Quiz) => (() => ({busy: false, quiz: q})) // shorthand to not have to write {busy: false, quiz: ...} everytime
  return [
    { section: "Init/Cover",
      mocks: [
        ["Loading", () => ({ busy: true })],
        ["Image + Title", quiz({meta: {...meta(0, 10), title: "Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019"}, cover: {image: coverImage, }})],
        ["Image + Title + Subtitle", quiz({meta: {...meta(0, 10), title: "Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019"}, cover: {image: coverImage, subtitle: "Adventskalender 2019"}})],
        ["with Image credits", quiz({meta: {...meta(0, 10), title: "Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019"}, cover: {image: coverImage, subtitle: "Adventskalender 2019", image_credit: "Copyright 2020"}})],
        ["without image", quiz({meta: {...meta(0, 10), title: "Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019"}, cover: {subtitle: "Adventskalender 2019"}})],
        ["Long title (doesn't fit mobile height)", quiz({meta: {...meta(0, 10), title: "Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019. Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019. Zum Ersten, zum Zweiten, zum Dritten: Versteigerungen 2019."}, cover: {image: coverImage, subtitle: "Adventskalender 2019"}})],
        ["with long HTML introduction", quiz({meta: {...meta(0, 10), introduction: longIntroText}, cover: {image: coverImage, subtitle: "Cartoon-Quiz"}})],
      ] },
    { section: "Question",
      mocks: [
        ["Only Text", quiz({meta: meta(1, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
        }})],
        ["More than 10 questions", quiz({meta: meta(1, 15), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
        }}), "should skip question ani to not annoy users"],
        ["Only Text", quiz({meta: {...meta(1, 88), hide_points: true}, question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
        }}), "Hide points (for personality-test-multi)"],
        ["Very long question", quiz({meta: meta(10, 10), question: {
          ...defaultQuestion,
          text: "Gut ein Jahr nachdem Banksy ein versteigertes Bild schredderte, kam Anfang Oktober 2019 wieder ein Gemälde des Street-Art-Künstlers unter den Hammer. „Devolved Parliament“ zeigt Schimpansen auf den Bänken des britischen Unterhauses. Allerdings hatte Banksy das Gemälde, das er ursprünglich 2009 unter dem Titel „Question Time“ angefertigt hatte, mittlerweile leicht verändert. Wie?",
        }}), "(taken from an actual quiz)"],
        ["with Hint", quiz({meta: meta(2, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          hint: "Australische Forscher veröffentlichten 2019 eine Langzeitstudie zu den Risiken von Kaffee für Herz-Kreislauf-Erkrankungen."
        }})],
        ["HTML in question + hint", quiz({meta: meta(2, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele <a href='#'>Tassen Kaffee</a> pro Tag sind laut den Wissenschaftlern unbedenklich?",
          hint: "<a href='#'>Australische Forscher</a> veröffentlichten 2019 eine Langzeitstudie zu den Risiken von Kaffee für Herz-Kreislauf-Erkrankungen."
        }})],
        ["with landscape Image", quiz({meta: meta(3, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          image: questionImageWide,
          image_or_video_subtext: "Copyright 2020"
        }})],
        ["with portrait Image", quiz({meta: meta(4, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          image: questionImageTall,
          image_or_video_subtext: "Copyright 2020"
        }})],
        ["with Video", quiz({meta: meta(5, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          video,
          image_or_video_subtext: "Copyright 2020"
        }})],
        ["with Image + hint", quiz({meta: meta(4, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          hint: "Australische Forscher veröffentlichten 2019 eine Langzeitstudie zu den Risiken von Kaffee für Herz-Kreislauf-Erkrankungen.",
          image: questionImageTall,
          image_or_video_subtext: "Copyright 2020"
        }}), "... also making it too high to fit on mobile"],
        ["With countdown", quiz({meta: meta(6, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          image: questionImageWide,
          countdown: {millis_left: 20000, millis_total: 20000},
          image_or_video_subtext: "Copyright 2020",
          config: undefined // when countdown not started: don't send answer-config
        }}), "Clicking on 'Frage beantworten' starts loading the possible answers from the server. On this sandbox page there will be no result"],
        ["With countdown (but no Image)", quiz({meta: meta(7, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          countdown: {millis_left: 20000, millis_total: 20000},
          image_or_video_subtext: "Copyright 2020",
          config: undefined // when countdown not started: don't send answer-config
        }})],
        ["With countdown BUT STARTED", quiz({meta: meta(8, 10), question: {
          ...defaultQuestion,
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          countdown: {millis_left: 12000, millis_total: 20000},
          image: questionImageWide,
          image_or_video_subtext: "Copyright 2020",
        }}), "(can occur after page reload while answering. In this case we won't slowly fade first the image then the text, but all at once)"],
      ] },
    { section: "Answers",
      mocks: [
        ["Small answers, everything fits", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]}
        }})],
        ["↳ eval: try again", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            try_again: {
              wrong_picked_values: [1, 2]
            }
          }
        } as Quiz.Api.MultipleChoiceQuestion})],
        ["↳ eval: Correct, continue to next question", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: true
            }
          }
        }})],
        ["↳ eval: same, but with 'Krebs' in meta, so only respectful icon shown", quiz({meta: {...meta(10, 20), title: "Quiz zu Krebsforschung und Krebsvorsorge"}, question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: true
            }
          }
        }})],
        ["↳ eval: Correct, quiz over -> see your result", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: false,
              can_continue: true,
              was_correct: true
            }
          }
        }})],
        ["↳ eval: Wrong, but tries left", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              num_wrong_answers_left: 3
            }
          }
        }})],
        ["↳ eval: Wrong, but tries left, BUT IS LAST QUESTION", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: false,
              can_continue: true,
              was_correct: false,
              num_wrong_answers_left: 3
            }
          }
        }}), "so don't show 'You only have X tries left'"],
        ["↳ eval: Wrong, TIMEOUT", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              was_timeout: true,
              num_wrong_answers_left: 3
            }
          }
        }}), "(because server sends was_timeout)"],
        ["↳ eval: Wrong, TIMEOUT", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 0, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              num_wrong_answers_left: 3
            }
          }
        }}), "(because !was_correct and no millis left)"],
        ["↳ eval: Wrong, game over", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: false,
              was_correct: false
            }
          }
        }})],
        ["↳ eval: Correct with long explanation", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "1", val: 1}, {text: "6", val: 2}, {text: "12", val: 3}
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: true,
              explanation: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet."
            }
          }
        }})],
        ["Answers with images", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, text: "Large image", image_display_size: "large", val: 5},
          ]}
        }})],
        ["↳ mark wrong", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}
          ]},
          eval: {
            try_again: {
              wrong_picked_values: [2, 3]
            }
          }
        } as Quiz.Api.MultipleChoiceQuestion})],
        ["Long answers, doesn't fit on mobile", quiz({meta: meta(15, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          config: { type: "multiple_choice", options: [
            {text: "Die Symptome zeigen sich noch am selben Tag einer Ansteckung. Lange Antwortmöglichkeit 1", val: 1},
            {text: "Die Symptome zeigen sich noch am selben Tag einer Ansteckung. Lange Antwortmöglichkeit 2", val: 2},
            {text: "Die Symptome zeigen sich noch am selben Tag einer Ansteckung. Lange Antwortmöglichkeit 3", val: 3}
          ]}
        }})],
        ["MultiSelect", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5},
          ]}
        } as Quiz.Api.MultiSelectQuestion})],
        ["↳ try again", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5},
          ]},
          eval: {
            try_again: {
              type: "multi_select",
              previous_picked_options: [1, 2],
            }
          }
        } as Quiz.Api.MultiSelectQuestion})],
        ["↳ wrong, reveal correct options", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5},
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              result_info: {
                type: "multi_select",
                correct_options: [1, 2]
              }
            }
          }
        } as Quiz.Api.MultiSelectQuestion})],
        ["↳ wrong, reveal correct options + explanation", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3},
          ]},
          eval: {
            result: {
              explanation: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              result_info: {
                type: "multi_select",
                correct_options: [1, 2]
              }
            }
          }
        } as Quiz.Api.MultiSelectQuestion})],
        ["↳ wrong, reveal correct options + explanation + tries left", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3},
          ]},
          eval: {
            result: {
              explanation: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              num_wrong_answers_left: 3,
              result_info: {
                type: "multi_select",
                correct_options: [1, 2]
              }
            }
          }
        } as Quiz.Api.MultiSelectQuestion})],
        ["↳ wrong, no correct options", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, countdown: {millis_left: 200000, millis_total: 200000}, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "multi_select", options: [
            {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5},
          ]},
          eval: {
            result: {
              has_more_questions: true,
              can_continue: true,
              was_correct: false,
              result_info: {
                type: "multi_select",
                correct_options: []
              }
            }
          }
        } as Quiz.Api.MultiSelectQuestion})],
        ["MatchPairs", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5} ],
            options_right: [ {text: "Match No image", val: 101}, {image: questionImageWide, image_credit: "image credit", text: "Match Text + image", val: 102}, {image: questionImageWide, image_credit: "image credit", val: 103}, {image: questionImageWide, text: "Match Text + image (but no credit)", val: 104}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 105} ],
          }
        } as Quiz.Api.MatchPairsQuestion})],
        ["↳ image + text to text", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion,
          text: "Welches Tier macht welches Geräusch?",
          image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {image: questionImageWide, text: "Hund", val: 1},  {image: questionImageTall, text: "Katze", val: 2}, {image: questionImageWide, text: "Elefant", val: 3} ],
            options_right: [ {text: "Töröö", val: 101}, {text: "Wuff", val: 102}, {text: "Miau", val: 103} ],
          }
        } as Quiz.Api.MatchPairsQuestion})],
        ["↳ image to text", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion,
          image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {image: questionImageWide, image_credit: "image credit", val: 1},  {image: questionImageTall, image_credit: "image credit", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3} ],
            options_right: [ {text: "Option A", val: 101}, {text: "Option B", val: 102}, {text: "Option C", val: 103} ],
          }
        } as Quiz.Api.MatchPairsQuestion})],
        ["↳ text to image", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {text: "Option A", val: 101}, {text: "Option B", val: 102}, {text: "Option C", val: 103} ],
            options_right: [ {image: questionImageWide, image_credit: "image credit", val: 1},  {image: questionImageTall, image_credit: "image credit", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3} ],
          }
        } as Quiz.Api.MatchPairsQuestion})],
        ["↳ try again", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5} ],
            options_right: [ {text: "Match No image", val: 101}, {image: questionImageWide, image_credit: "image credit", text: "Match Text + image", val: 102}, {image: questionImageWide, image_credit: "image credit", val: 103}, {image: questionImageWide, text: "Match Text + image (but no credit)", val: 104}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 105} ],
          },
          eval: {
            try_again: {
              type: "match_pairs",
              previous_matches: [{ left: 1, right: 101 }],
            }
          }
        } as Quiz.Api.MatchPairsQuestion})],
        ["↳ Eval Overlay", quiz({meta: meta(10, 20), question: {
          ...defaultQuestion, image: questionImageWide,
          directlyShowAnswers: true,
          config: { type: "match_pairs",
            options_left: [ {text: "No image", val: 1}, {image: questionImageWide, image_credit: "image credit", text: "Text + image", val: 2}, {image: questionImageWide, image_credit: "image credit", val: 3}, {image: questionImageWide, text: "Text + image (but no credit)", val: 4}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 5} ],
            options_right: [ {text: "Match No image", val: 101}, {image: questionImageWide, image_credit: "image credit", text: "Match Text + image", val: 102}, {image: questionImageWide, image_credit: "image credit", val: 103}, {image: questionImageWide, text: "Match Text + image (but no credit)", val: 104}, {image: questionImageWide, image_credit: "image credit", text: "Large image", image_display_size: "large", val: 105} ],
          },
          eval: {
            result: {
              can_continue: true,
              has_more_questions: true,
              was_correct: true,
            }
          },
        } as Quiz.Api.MatchPairsQuestion})],
        ["Slider, 3 options", quiz({meta: meta(9, 10), question: {
          directlyShowAnswers: true,
          config: {
            type: "slider",
            options: [
              {val: 0, text: "Triff überhaupt nicht zu"},
              {val: 1, text: "Teils/teils"},
              {val: 2, text: "Triff voll zu"},
            ]
          },
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          image: questionImageWide,
          image_or_video_subtext: "Copyright 2020"
        }}), "should have label for each step below slider, no text above slider"],
        ["Slider, 5 options, try again", quiz({meta: meta(10, 10), question: {
          directlyShowAnswers: true,
          config: {
            type: "slider",
            options: [
              {val: 0, text: "Triff überhaupt nicht zu"},
              {val: 1, text: "Eher weniger"},
              {val: 2, text: "Mittel"},
              {val: 3, text: "Eher mehr"},
              {val: 4, text: "Triff voll zu"},
            ]
          },
          eval: {
            try_again: { type: "slider" }
          },
          text: "Bis zu wie viele Tassen Kaffee pro Tag sind laut den Wissenschaftlern unbedenklich?",
          image: questionImageWide,
          image_or_video_subtext: "Copyright 2020"
        }}), "should have label below only for first + last step, but text of selected step above slider"],
      ] },
    { section: "Final Quiz result",
      mocks: [
        ["Good", quiz({ meta: meta(10, 10), result: { share, normal_quiz: {
          grade: "good",
          image: coverImage,
          optin_text: exampleOptin
        }}}), "with optin, without result-text"],
        ["Good + EXTRA_CONTENT", quiz({ meta: meta(10, 10), result: { share, normal_quiz: {
          grade: "good",
          image: coverImage,
          optin_text: exampleOptin
        }, extra_content: "xmas-2020"}})],
        ["Good with 'needed minutes'", quiz({ meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          needed_minutes: "3:22",
          image: coverImage,
          optin_text: exampleOptin
        }}}), "no possible points set"],
        ["Entered Highscore", quiz({ meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          own_rank: 10,
          image: coverImage,
          optin_text: exampleOptin
        }}}), "Skips 'Quiz wird ausgewertet' animation"],
        ["Show enter-ranking-error", quiz({ meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          enter_ranking_error: "There was an error with your user token. Please logout/login again and try again.",
          image: coverImage,
          optin_text: exampleOptin
        }}})],
        ["Entered Highscore + EXTRA CONTENT", quiz({ meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          own_rank: 10,
          image: coverImage,
          optin_text: exampleOptin
        }, extra_content: "xmas-2020"}}), "... so your own-rank won't be shown! (it's a special requirement for xmas-quizzes)"],
        ["Entered Highscore + EXTRA CONTENT (only no-ranking)", quiz({ meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          own_rank: 10,
          image: coverImage,
          optin_text: exampleOptin
        }, extra_content: "no-ranking"}}), "... so your own-rank won't be shown! (it's a special requirement for xmas-quizzes)"],
        ["Entered Highscore + advertised_quizzes", quiz({ advertised_quizzes: [
            { title: "Adventsquiz: 7. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 6. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 4. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 3. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 1. Dezember 2020", url: "#todo" }
          ], meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          own_rank: 10,
          image: coverImage,
          optin_text: exampleOptin
        }}}), "... so your own-rank won't be shown! (it's a special requirement for xmas-quizzes)"],
        ["Entered Highscore + EXTRA CONTENT + advertised_quizzes", quiz({ advertised_quizzes: [
            { title: "Adventsquiz: 7. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 6. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 4. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 3. Dezember 2020", url: "#todo" },
            { title: "Adventsquiz: 1. Dezember 2020", url: "#todo" }
          ], meta: {...meta(10, 10), possible_points: undefined}, result: { share, normal_quiz: {
          grade: "good",
          own_rank: 10,
          image: coverImage,
          optin_text: exampleOptin
        }, extra_content: "xmas-2020"}}), "... so your own-rank won't be shown! (it's a special requirement for xmas-quizzes)"],
        ["Bad", quiz({ meta: meta(10, 10), result: { share, normal_quiz: {
          grade: "bad",
          image: coverImage,
          result_text: "Das war unser Quiz zu diesem Thema. Und dies ist die <a href='#'>Ergbnisbeschreibung</a>. Das war diesmal leider nichts, du musse noch mehr üben.",
        }}}), "without optin, with result_text"],
        ["Acceptable", quiz({ meta: meta(10, 10), result: { share, normal_quiz: {
          grade: "acceptable",
          optin_text: exampleOptin
        }}}), "without image"],
        ["8 questions", quiz({ meta: meta(8, 8), result: { share, normal_quiz: {grade: "good"} } }), "to check the 'Quiz wird ausgewertet' animation"],
        ["10 questions", quiz({ meta: meta(10, 10), result: { share, normal_quiz: {grade: "good"} } }), "to check the 'Quiz wird ausgewertet' animation"],
        ["30 questions", quiz({ meta: meta(30, 30), result: { share, normal_quiz: {grade: "good"} } }), "to check the 'Quiz wird ausgewertet' animation"],
        ["Personality Test (Points)", quiz({meta: meta(30, 30), result: {
          share,
          personality_test_points: {
            points: 3,
            result_text: "Es passiert Ihnen schon einmal, dass Sie <a>Dinge vor sich her schieben</a>, aber Sie <strong>empfinden</strong> das zu Recht nicht als Problem. Die meisten Ihrer Pläne setzen Sie auch um. Bei Schwierigkeiten finden Sie deren Ursachen heraus und stellen Sie ab.",
            points_to_result: [
              { points: "0 - 5 Punkte", result: "Glückwunsch, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "6 - 10 Punkte", result: "Naja, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "11 - 20 Punkte", result: "Ups, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
            ]
          }
        }})],
        ["Personality Test (Points)", quiz({meta: meta(30, 30), result: {
          share,
          personality_test_points: {
            points: 3,
            result_text: "Es passiert Ihnen schon einmal, dass Sie <a>Dinge vor sich her schieben</a>, aber Sie <strong>empfinden</strong> das zu Recht nicht als Problem. Die meisten Ihrer Pläne setzen Sie auch um. Bei Schwierigkeiten finden Sie deren Ursachen heraus und stellen Sie ab.",
            image: coverImage,
            image_credit: "(c) 1996 FB",
            points_to_result: [
              { points: "0 - 5 Punkte", result: "Glückwunsch, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "6 - 10 Punkte", result: "Naja, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "11 - 20 Punkte", result: "Ups, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
            ]
          }
        }}), "with Image"],
        ["Personality Test (Multi)", quiz({meta: meta(30, 30), result: {
          share,
          personality_test_multi: {
            result_title: "Irland",
            result_text: "Es passiert Ihnen schon einmal, dass Sie <a>Dinge vor sich her schieben</a>, aber Sie <strong>empfinden</strong> das zu Recht nicht als Problem. Die meisten Ihrer Pläne setzen Sie auch um. Bei Schwierigkeiten finden Sie deren Ursachen heraus und stellen Sie ab.",
            image: coverImage,
            image_credit: "(c) 1996 FB",
            result_table: [
              { points: "5 Punkte", title: "Irland" },
              { points: "10 Punkte", title: "Kreta" },
              { points: "20 Punkte", title: "Rügen" },
            ]
          }
        }}), "with Image"],
        ["Personality Test (Multi)", quiz({meta: {...meta(30, 30), title: "Emotionale Intelligenz - Der kostenlose EQ-Test mit Sofortergebnis"}, result: {
          share,
          personality_test_multi: {
            result_text: "",
            result_title: "EQ",
            result_table: [
              { points: "120 Punkte", title: "EQ" },
              { points: "45 Punkte", title: "Gelassenheit" },
              { points: "39 Punkte", title: "Geselligkeit" },
              { points: "33 Punkte", title: "Extrovertiertheit" },
              { points: "33 Punkte", title: "Geschlechtsspezifisch" },
              { points: "30 Punkte", title: "Depressiv" },
              { points: "26 Punkte", title: "Aggressivität" },
              { points: "25 Punkte", title: "Nervosität" },
              { points: "23 Punkte", title: "Erregbarkeit" }
            ]
          }
        }}), "EQ Test - where just showing the highest category looks odd"],
        ["Personality Test (Points)", quiz({meta: meta(30, 30), result: {
          share,
          extra_content: "xmas-2020",
          personality_test_points: {
            points: 3,
            result_text: "Es passiert Ihnen schon einmal, dass Sie <a>Dinge vor sich her schieben</a>, aber Sie <strong>empfinden</strong> das zu Recht nicht als Problem. Die meisten Ihrer Pläne setzen Sie auch um. Bei Schwierigkeiten finden Sie deren Ursachen heraus und stellen Sie ab.",
            points_to_result: [
              { points: "0 - 5 Punkte", result: "Glückwunsch, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "6 - 10 Punkte", result: "Naja, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
              { points: "11 - 20 Punkte", result: "Ups, Aufschieben gehört nicht zu Ihren <a>Angewohnheiten</a>. Sie haben die richtigen Einstellungen, um Ihre Sachen schnell und mühelos zu erledigen. Sie überfordern sich nicht und bleiben auch bei Schwierigkeiten locker." },
            ]
          }
        }}), "With extra content"]
      ] },
  ]
}

const SUBPAGE_OFFSET_PER_SECTION = 100

export const getMockForSubpage = (subpage?: number) => {
  if (typeof subpage === "number") {
    const mocks = getMocks()
    const mock = mocks[Math.floor(subpage / SUBPAGE_OFFSET_PER_SECTION)].mocks[subpage % SUBPAGE_OFFSET_PER_SECTION]
    return mock?.[1]?.()
  }
  return undefined
}

const Mocks: React.FC<{setState(state: IMockState, mockSubpageIndex: number): void}> = ({ setState }) => {
  return (
    <div>
      {_.map(getMocks(), (section, index) => {
        return <div key={index}>
          <h3>{section.section}</h3>
          <ul>
            {_.map(section.mocks, ([name, state, info], mi) => {
              return <li key={mi}>
                <a onClick={() => setState(state(), index * SUBPAGE_OFFSET_PER_SECTION + mi)}>{name}</a>
                {info && ` ${info}`}
              </li>
            })}
          </ul>
        </div>
      })}
    </div>
  )
}

export default Mocks
